const errorMessages = {
  INCORRECT_PASSWORD: 'La contraseña es invalida.',
  TRADER_NOT_FOUND: 'El correo electrónico no está registrado.'
};

export default errorMessages;
